import html2canvas from "html2canvas";
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { ProjectMapContent } from "../MapTab/ProjectMapContent";
import { useStepClickHandler } from "./hooks/useStepClickHandler";
import { useWPRContext } from "./hooks/useWPRContext";
import { StepChildProps } from "./WPRStepper";

export const WPRStepOne = ({
  stepChangeClickedType,
  setActiveStep,
  setStepChangeClickedType,
}: StepChildProps) => {
  const { setBase64Url } = useWPRContext();

  const targetRef = useRef<HTMLElement | undefined>();
  const { t } = useTranslation("");
  const screenshot = React.useCallback(() => {
    if (!targetRef.current) return Promise.resolve();
    // return new Promise((res, rej) => {
    //   rej(new Error("moi"));
    // });

    // eslint-disable-next-line consistent-return
    // return timeout(5000);

    return html2canvas(targetRef.current).then((e) => {
      setBase64Url(e.toDataURL("image/png"));
    });
  }, [setBase64Url]);

  const handleImageRemove = React.useCallback(() => {
    setBase64Url("");
  }, [setBase64Url]);

  useStepClickHandler({
    nextStepFn: screenshot,
    setActiveStep,
    backStepFn: handleImageRemove,
    stepChangeClickedType,
    setStepChangeClickedType,
    loadingText: t("WPR:generatingImage"),
  });

  return (
    <>
      <ProjectMapContent wprView targetRef={targetRef} />
    </>
  );
};

// export const useWPRStepOne = () => {
//   const { setBase64Url } = useWPRContext();
//   const [creatingImage, setCreatingImage] = React.useState<boolean>(false);
//   const targetRef = useRef();

//   const screenshot = React.useCallback(() => {
//     if (!targetRef.current) return;
//     setCreatingImage(true);
//     void html2canvas(targetRef.current).then((e) => {
//       setBase64Url(e.toDataURL("image/png"));
//       setCreatingImage(false);
//     });
//   }, [setBase64Url]);

//   const handleImageRemove = React.useCallback(() => {
//     setBase64Url("");
//   }, [setBase64Url]);

//   const content = React.useMemo(
//     () => <ProjectMapContent wprView targetRef={targetRef} />,
//     [],
//   );

//   return React.useMemo(
//     () => ({
//       content,
//       title: "määritä kartan asetukset",
//       onNextStep: screenshot,
//       onBackStep: handleImageRemove,
//     }),
//     [content, handleImageRemove, screenshot],
//   );
// };
